import { trackEvent } from '../analytics/analytics'
import { TRACK_EVENTS } from '../../constants'

// The field-panel Layers tab and Season Layers tab share the same row component, so every
// layer event carries a `tab` discriminator telling them apart in Segment.
export const LAYER_TABS = {
  LAYERS: 'layers',
  SEASON_LAYERS: 'seasonLayers'
}

const PLATFORM = 'web'

// app_version has no source in this repo yet (REACT_APP_VERSION is unset and react-scripts
// does not inline package.json's version — issue #1401). Attach it only when a build actually
// provides it so we never emit a placeholder. Mirrors feedback/csatTracking.js.
const getAppVersion = () => process.env.REACT_APP_VERSION || undefined

// Stamp platform + location + (when present) app_version, and drop empty values so events
// carry no null/'' noise. `false` and `0` are intentionally kept (a hidden layer / zero opacity).
const withBaseProperties = (properties = {}) => {
  const merged = { platform: PLATFORM, app_version: getAppVersion(), location: TRACK_EVENTS.FIELD_PANEL, ...properties }
  return Object.keys(merged).reduce((accumulator, key) => {
    const value = merged[key]
    if (value !== undefined && value !== null && value !== '') accumulator[key] = value
    return accumulator
  }, {})
}

// Eye toggle. `visible` is the NEW state (true = activated, false = deactivated).
export const trackLayerVisibilityToggled = ({ layer, typeId, visible, tab }) =>
  trackEvent(TRACK_EVENTS.FIELD_LAYER_VISIBILITY_TOGGLED, withBaseProperties({ layer, typeId, visible, tab }))

// Opacity/alpha slider, fired once on release (commit) with the resulting 0–1 value.
export const trackLayerOpacityChanged = ({ layer, typeId, opacity, tab }) =>
  trackEvent(TRACK_EVENTS.FIELD_LAYER_OPACITY, withBaseProperties({ layer, typeId, opacity, tab }))

// Drag-reorder, fired once on drop with the moved layer and its from/to positions.
export const trackLayerReordered = ({ id, name, from, to, tab }) =>
  trackEvent(TRACK_EVENTS.FIELD_LAYER_ORDERED, withBaseProperties({ id, name, from, to, tab }))
